module.exports = __webpack_public_path__ + "static/img/username.e4575887.svg";